import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  walletPhoneVerificationRequired: {
    description: 'Error message displayed when a user must verify their phone number to purchase postage',
    defaultMessage:
      'You must verify your account with a valid phone number before you can purchase postage. <b>Click here to verify your account.</b>',
    id: 'LuBcGL',
  },
});
